import { Box, Button, Card, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  AddressIcon,
  RightArrow,
  UserIcon,
} from "../../components/svgComponent/ManageAccountSvg";
import HeadingWithDescription from "../../components/headingWithDescription";
import { LogoutOutlined } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { logout } from "../../store/Slices/authSlice";
import MicrowaveIcon from "@mui/icons-material/Microwave";
import { PRIMARY_COLOR } from "../../constants";

const SingleRow = ({
  title,
  description,
  path,
}: {
  title: string;
  description: string;
  path: string;
}) => {
  const navigate = useNavigate();

  return (
    <Card
      elevation={2}
      className=" cursor-pointer"
      onClick={() => navigate(path)}
    >
      <Box p={2} display="flex" gap={2} alignItems="center">
        {title === "Personal Info" && <UserIcon fill={PRIMARY_COLOR} />}
        {title === "Addresses" && <AddressIcon fill={PRIMARY_COLOR} />}
        {title === "Appliances" && <MicrowaveIcon color="primary" />}
        <Box
          flex={1}
          sx={{ display: "flex", flexDirection: "column" }}
          gap={0.2}
        >
          <Typography fontWeight="500">{title}</Typography>
          <Typography variant="body2" color="#666">
            {description}
          </Typography>
        </Box>
        <RightArrow />
      </Box>
    </Card>
  );
};

export default function ManageAccount() {
  const dispatch = useDispatch();
  return (
    <Stack flex={1}>
      <Box p={2}>
        <HeadingWithDescription heading="My Account" description="" />
      </Box>
      <Stack p={2} flex={1} gap={1}>
        <SingleRow
          title="Personal Info"
          description="View personal details"
          path="personal-info"
        />
        <SingleRow
          title="Addresses"
          description="View addresses / Add location"
          path="addresses"
        />
        <SingleRow
          title="Appliances"
          description="View all registered appliances"
          path="machines"
        />
        <Box flex={1}/>
        <Button
          onClick={() => {
            dispatch(logout());
          }}
          sx={{ my: 5 }}
          className="flex gap-2"
          color="secondary"
        >
          {" "}
          <LogoutOutlined /> Logout
        </Button>
      </Stack>
    </Stack>
  );
}
